import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { ReactComponent as LogoSVG } from './inv_logo.svg';
import { awsServer } from '../../utilities/UrlPaths';

const Payments = () => {
  const { houseUserName } = useSelector(state => state.house);
  const { action } = useParams() || '';
  const isScheduleVersion = action === 'switch';

  return (
    <>
      <Row className="opal-bkgd">
        <Col xs={12}>
          <div className="mt-5 mb-4 text-center">
            <LogoSVG className="logo-400" />
          </div>
        </Col>
        <Col xs={2} />
        <Col xs={8}>
          <div className=" text-center px-5 payments-top-title">
            <div className="enrollment-reminder">
              <b>Action Required:</b> Sign up for Invaluable Payments Today.<br />
              Invaluable Payments will be required starting in <span>January</span> to continue posting sales on Invaluable.
            </div>
            {isScheduleVersion && (
              <div>Schedule an appointment with our payments team to make the switch.</div>
            )}
          </div>
          <div className="my-4 pb-3 text-center">
            <a
              href={
                isScheduleVersion
                  ? 'https://calendly.com/payments-inv'
                  : `https://payments.invaluableauctions.com/signup/InvaluablePayments?custom=${houseUserName}`
              }
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary"
            >
              {isScheduleVersion ? 'Book Appointment' : 'Sign Up Now'}
            </a>
          </div>
        </Col>
        <Col xs={2} />
      </Row>
      <Container className="mt-0 pt-0 pb-5">
        <Row className="mt-5">
          <Col xs={5}>
            <h1 className="pb-3 border-bottom h1-no-cap">
              {isScheduleVersion
                ? ' Benefits of Switching from Stripe'
                : 'Game-Changing Features'}
            </h1>
            <div>
              <div className="font-weight-bold mt-3">Ensure Timely Payment</div>
              <div>
                Use our new auto-charge feature to automatically batch charge bidder credit cards.
              </div>
            </div>
            <div>
              <div className="font-weight-bold mt-3">Add New Charges After Invoice Payment</div>
              <div>
                Add extra shipping or insurance charges after you receive your invoice payment.
              </div>
            </div>
            <div>
              <div className="font-weight-bold mt-3">Enable ACH Bank Transfer</div>
              <div>
                Receive ACH payments exclusively or for any items sold above your specified amount.
              </div>
            </div>
            <div>
              <div className="font-weight-bold mt-3">Take Advantage of Sales Tax Handling</div>
              <div>
                Let us collect and remit the appropriate sales tax amount on your behalf for US
                bidders.
              </div>
            </div>
            <div>
              <div className="font-weight-bold mt-3">Automate Tax-Exempt Bidder Status</div>
              <div>
                Sales tax will be automatically removed from invoices for bidders who provide
                tax-exempt paperwork.
              </div>
            </div>
            <div className="mt-4">
              <a
                href={
                  isScheduleVersion
                    ? 'https://calendly.com/payments-inv'
                    : `https://payments.invaluableauctions.com/signup/InvaluablePayments?custom=${houseUserName}`
                }
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary"
              >
                {isScheduleVersion ? 'Book Appointment' : 'Sign Up Now'}
              </a>
            </div>
          </Col>
          <Col xs={7}>
            <div>
              <img src={`${awsServer}/static/paymentsPhoto.jpg`} alt="payments" className="w-100" />
            </div>
          </Col>
        </Row>
      </Container>
      <Row className="garnet-bkrd mt-4">
        <Col xs={12}>
          <Container className="mt-0 pt-0 my-4">
            <div className="white-text">
              Visit our FAQs page to
              <a
                href="https://www.invaluableauctions.com/inv/help-center/faq/invaluable-payments/"
                className="white-link ml-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                learn more.
              </a>
            </div>
          </Container>
        </Col>
      </Row>
    </>
  );
};

export default Payments;
